// extracted by mini-css-extract-plugin
export default {"cursor":"Cursor_cursor__PH4Un","cursorHover":"Cursor_cursorHover__x6hVb","cursorTrail":"Cursor_cursorTrail__bWZl0"};